if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        const sectionId = this.id.replace('ProductModal-', '');
        const gallery = document.getElementById(`MediaGallery-${sectionId}`);
        const content = this.querySelector('.product-media-modal__content');

        if (gallery?.dataset.colorFilter === 'true' && content) {
          const allowedIds = new Set(
            (gallery.dataset.colorMediaIds || '').split(',').filter(Boolean)
          );
          const items = [...content.querySelectorAll('[data-media-id]')];
          const openerId = opener.getAttribute('data-media-id');
          const openerMediaId = openerId?.split('-').pop();

          if (
            allowedIds.size &&
            allowedIds.has(openerMediaId) &&
            items.some((item) => item.dataset.mediaId === openerId)
          ) {
            items.forEach((item) => {
              const mediaId = item.dataset.mediaId.split('-').pop();
              if (!allowedIds.has(mediaId)) item.remove();
            });
          }
        }

        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
